import { Typography } from '../../designComponents';
import { InfoRowStyled, VerticalSpaceStyled } from '../../style/reusableStyle';
import { BrowsedJobDetailsContainerStyled } from '../TechnicianBrowsedJobDetails/style';

type Props = {
  shippingAddress: string;
  companyAddress?: string;
};

const AdditionalInformation = ({ companyAddress, shippingAddress }: Props) => {
  return (
    <BrowsedJobDetailsContainerStyled>
      <Typography
        variant="normal"
        strong
        fontColor="secondary"
        className="section-title"
      >
        ADDITIONAL INFORMATION
      </Typography>
      <VerticalSpaceStyled>
        <InfoRowStyled className="jobInformation">
          <Typography className="title">Shipping Address:</Typography>
          <Typography className="value">{shippingAddress}</Typography>
        </InfoRowStyled>
        {companyAddress && (
          <InfoRowStyled className="jobInformation">
            <Typography className="title">Company Address:</Typography>
            <Typography className="value">{companyAddress}</Typography>
          </InfoRowStyled>
        )}
      </VerticalSpaceStyled>
    </BrowsedJobDetailsContainerStyled>
  );
};

export default AdditionalInformation;
